import { toast } from "react-toastify";
import * as XLSX from "xlsx";

export const createCSVContent = (exportData) => {
  const headers = Object.keys(exportData[0]);
  return [
    headers.join(","),
    ...exportData.map((row) =>
      headers
        .map((header) => {
          const value = row[header] || "";
          return `"${value.toString().replace(/"/g, '""')}"`;
        })
        .join(",")
    ),
  ].join("\n");
};

export const createExcelFile = (exportData) => {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(exportData);

  // Auto-size columns
  const range = XLSX.utils.decode_range(worksheet["!ref"]);
  const colWidths = [];
  for (let c = range.s.c; c <= range.e.c; c++) {
    let maxWidth = 0;
    for (let r = range.s.r; r <= range.e.r; r++) {
      const cellAddress = XLSX.utils.encode_cell({ c, r });
      const cell = worksheet[cellAddress];
      if (cell && cell.v) {
        const width = cell.v.toString().length;
        maxWidth = Math.max(maxWidth, width);
      }
    }
    colWidths[c] = { wch: Math.min(maxWidth + 2, 50) };
  }
  worksheet["!cols"] = colWidths;
  XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
  return workbook;
};

// Optimized file download with modern API fallback
export const downloadFile = async (blob, filename) => {
  const hasShowSaveDialog = "showSaveFilePicker" in window;

  if (hasShowSaveDialog) {
    try {
      const fileHandle = await window.showSaveFilePicker({
        suggestedName: filename,
        types: [
          {
            description: filename.endsWith(".csv")
              ? "CSV files"
              : "Excel files",
            accept: filename.endsWith(".csv")
              ? { "text/csv": [".csv"] }
              : {
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    [".xlsx"],
                },
          },
        ],
      });

      const writable = await fileHandle.createWritable();
      await writable.write(blob);
      await writable.close();
      return true;
    } catch (error) {
      if (error.name === "AbortError") {
        toast.info("Save cancelled by user");
        return false;
      }
      throw error;
    }
  } else {
    // Fallback: traditional download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
    return true;
  }
};
